var map = {
	"./Correct/250_Question/Coin.wav": 61704,
	"./Correct/250_Question/PopBells.mp3": 35886,
	"./Correct/250_Question/correct.mp3": 11251,
	"./Correct/500_Questions/AppMoney1.mp3": 85322,
	"./Correct/500_Questions/AppMoney2.mp3": 23325,
	"./Correct/500_Questions/CashMachine.mp3": 15850,
	"./Correct/500_Questions/GlockSuccessDing.mp3": 58229,
	"./Correct/750_Questions/MoneyCoins1.mp3": 35640,
	"./Correct/750_Questions/MoneyCoins2.mp3": 51887,
	"./Correct/750_Questions/PopWin1.mp3": 72149,
	"./Correct/750_Questions/PopWin2.mp3": 62370,
	"./Correct/Double_Points/250_Question/GamePops1.mp3": 68776,
	"./Correct/Double_Points/250_Question/GamePops3.wav": 5062,
	"./Correct/Double_Points/500_Questions/DigitalLoading.mp3": 38888,
	"./Correct/Double_Points/500_Questions/DigitalText.wav": 44281,
	"./Correct/Double_Points/500_Questions/GamePops2.mp3": 71528,
	"./Correct/Double_Points/750_Question/CorrectAnswerRings.mp3": 75453,
	"./Correct/Pit/250_Question/GamePops4.wav": 58377,
	"./Correct/Pit/500_Questions/GamePops5.wav": 87039,
	"./Correct/Pit/500_Questions/StrongPunch2.wav": 98999,
	"./Correct/Pit/500_Questions/SwordSlashA.mp3": 27139,
	"./Correct/Pit/750_Question/GamePops6.wav": 82548,
	"./Correct/Pit/750_Question/PopPoppingDown.wav": 62758,
	"./EndGame/1000_2000_Difference/HappyFanfare.mp3": 92799,
	"./EndGame/1000_2000_Difference/WinFanfare.wav": 30751,
	"./EndGame/1000_2000_Difference/Winning.mp3": 65762,
	"./EndGame/2250_2750_Difference/MoneyWinner.wav": 6767,
	"./EndGame/250_750_difference/Win1.mp3": 54065,
	"./EndGame/3000_Difference/Easy_Money_Alert_TTX020704.wav": 24245,
	"./EndGame/Tie/Sword.wav": 11163,
	"./Selected_Lifeline/Additional_Time/ClockMechanism.wav": 90085,
	"./Selected_Lifeline/Call_A_friend/Cell_Phone.wav": 76807,
	"./Selected_Lifeline/Call_A_friend/Phone_Ring.wav": 68507,
	"./Selected_Lifeline/Call_A_friend/TelephoneRing1.wav": 73005,
	"./Selected_Lifeline/Call_A_friend/TelephoneRing2.wav": 43906,
	"./Selected_Lifeline/Call_A_friend/TelephoneRing3.wav": 99003,
	"./Selected_Lifeline/Double_points/Powerup.wav": 42538,
	"./Selected_Lifeline/Insurance/sHIELD.wav": 92624,
	"./Selected_Lifeline/Pit/Shovel.wav": 87491,
	"./Selected_Lifeline/Pop.wav": 98385,
	"./Timer/FastTick.wav": 65914,
	"./Timer/TimeIsUp.mp3": 93899,
	"./Timer/TimerTicks.mp3": 77856,
	"./Wrong/250_Question/Fart.mp3": 91355,
	"./Wrong/250_Question/WrongAnswer2.wav": 40947,
	"./Wrong/Wrong.wav": 61470,
	"./Wrong/WrongAnswer.mp3": 72344,
	"./Wrong/WrongAnswer2.wav": 41486,
	"./Wrong/WrongOption1.mp3": 15730,
	"./XAnswered/Pop.wav": 74166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47217;